import { TimeSeriesChartData } from '@customTypes';
import { DATA_SPLIT_SIGN } from '@constants';

import { nullableNumberToString } from './nullableNumberToString';

export const getTimeChartDataForTable = (inputData: TimeSeriesChartData): { headers: string[]; data: string[] } => {
  const headers = ['name'];
  headers.push(...inputData.series.map((record) => `\0${record.name}`));

  const data = inputData.xaxis.categories!.map((record, index) => {
    return `${record},${inputData.series.map((s) => nullableNumberToString(s.data[index])).join(DATA_SPLIT_SIGN)}`;
  });

  return { headers, data };
};
